import React from 'react';
import {
  Box, IconButton, Paper, Skeleton, Table, TableBody, TableCell, TableContainer,
  TableHead, TablePagination, TableRow, Tooltip, Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const SKELETON_ROWS = 5;

const DemoTable = ({ demos, loading, onEdit, onDelete, onPreview, page, rowsPerPage, total, onPageChange, onRowsPerPageChange }) => (
  <>
  <TableContainer component={Paper} variant="outlined">
    <Table size="small">
      <TableHead sx={{ bgcolor: 'grey.50' }}>
        <TableRow>
          <TableCell>ID</TableCell>
          <TableCell>Title</TableCell>
          <TableCell>Demo URL</TableCell>
          <TableCell>Description</TableCell>
          <TableCell align="right">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {loading
          ? Array.from({ length: SKELETON_ROWS }).map((_, i) => (
              <TableRow key={i}>
                <TableCell><Skeleton variant="text" width="60%" /></TableCell>
                <TableCell><Skeleton variant="text" width="80%" /></TableCell>
                <TableCell><Skeleton variant="text" width="90%" /></TableCell>
                <TableCell><Skeleton variant="text" width="70%" /></TableCell>
                <TableCell align="right" sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
                  <Skeleton variant="circular" width={28} height={28} />
                  <Skeleton variant="circular" width={28} height={28} />
                  <Skeleton variant="circular" width={28} height={28} />
                </TableCell>
              </TableRow>
            ))
          : demos.map((demo) => (
              <TableRow key={demo.id} sx={{ '&:hover': { bgcolor: 'action.hover' } }}>
                <TableCell>{demo.id}</TableCell>
                <TableCell>{demo.title}</TableCell>
                <TableCell>
                  <Tooltip title="Click to preview">
                    <Typography
                      variant="body2"
                      onClick={() => onPreview(demo)}
                      sx={{
                        maxWidth: 300,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                        color: 'primary.main',
                        '&:hover': { textDecoration: 'underline' },
                      }}
                    >
                      {demo.url}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell>{demo.description || '—'}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Preview Demo">
                    <IconButton size="small" color="primary" onClick={() => onPreview(demo)}>
                      <PlayCircleOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => onEdit(demo)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" color="error" onClick={() => onDelete(demo)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
      </TableBody>
    </Table>
  </TableContainer>
  <TablePagination
    component="div"
    count={total}
    page={page}
    rowsPerPage={rowsPerPage}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
    rowsPerPageOptions={[5, 10, 25]}
  />
  </>
);

export default DemoTable;
